import { CUSTOMER_JOURNEY_CATEGORIES_ERROR } from './../const';

function action(errorCallback) {
  return { type: CUSTOMER_JOURNEY_CATEGORIES_ERROR, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyCategoriesError.js